import type { ProductsUsageReport } from '@vy/types';
import { caseInsensitiveIncludes, isNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { VyTableLite } from '../../../../../components/new-design/table/vy-table/VyTable';
import { PRODUCTS_USAGE_REPORT_COLUMNS } from './ProductsUsageReportTableColumns';
import { GridApiPro } from '@mui/x-data-grid-pro';

type ProductsUsageReportTableProps = {
  rows: ProductsUsageReport;
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiPro>;
  isLoading?: boolean;
};

export const ProductsUsageReportTable: React.FC<ProductsUsageReportTableProps> = ({
  rows,
  isLoading,
  filter,
  apiRef,
}) => {
  const filteredRows = useMemo(
    () =>
      rows.filter(
        ({ customerName }) => isNullOrUndefined(filter) || caseInsensitiveIncludes(customerName, filter),
      ),
    [rows, filter],
  );

  return (
    <VyTableLite
      apiRef={apiRef}
      items={filteredRows}
      columns={PRODUCTS_USAGE_REPORT_COLUMNS}
      loadingItems={isLoading}
      getRowId={() => crypto.randomUUID()}
    />
  );
};
